import { GET_POST } from './constants';

export function loadPost(postId, preview = false) {
  let queryParams;
  if (preview) {
    queryParams = { preview: null };
  }

  return dispatch => dispatch({
    type: GET_POST,
    request: {
      method: 'GET',
      endpoint: `posts/${postId}/`,
      queryParams
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/Post/actions.js